module.exports = __webpack_public_path__ + "img/19.4482d57d.png";